import Ordinance from './Ordinance'

export default class ConfirmationOrdinance extends Ordinance {
  constructor(confirmation, t) {
    super({
      data: confirmation,
      title: t('wcf.person-ordinances.confirmation', 'Confirmation'),
      t,
    })
  }
}
